module.exports = Em.Controller.extend({
    queryParams: [
        'code',
        'scope',
        'state',
        'error',
        'error_description'
    ]
})
